<template>
  <tg-layout prefixCls="dashboard-detail" :class="{ isEveryDay: isEveryDay }">
    <template slot="header">
      <detail-header
        v-bind="headerProps"
        @on-export="handleExport"
      ></detail-header>
      <el-divider></el-divider>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      :show-summary="!isEveryDay"
      :summary-method="summary"
      :showPagination="!isEveryDay"
      :tableHeight="450"
      @on-loaded="handleLoaded"
      @sort-change="handleSortChange"
    >
      <span
        slot="cell"
        slot-scope="props"
        :class="{
          'text-red': props.value < 0,
          'text-green': props.value > 0,
        }"
      >
        {{ props.formated }}
      </span>
    </tg-table>
  </tg-layout>
</template>

<script>
import apis from "@/apis";
import formatter from "@/utils/formatter";

import detailHeader from "./detailHeader";
import TgLayout from "@/layout/TgLayout";

import xlsx from "@/utils/xlsx";
import { convertToRows, flatColumns } from "@/utils/table";
export default {
  name: "detail",
  components: {
    detailHeader,
    TgLayout,
  },
  data() {
    return {
      columns: [],
      detailColumns: [],
      everyDayColumns: [],
      proxy: apis.dashboard.getDetail,
      startTime: "",
      endTime: "",
      summaryData: {},
    };
  },
  props: {
    options: Object,
  },
  computed: {
    col() {
      return this.options.col;
    },
    row() {
      return this.options.row;
    },
    column() {
      return this.options.column;
    },
    isEveryDay() {
      return this.options.isEveryDay;
    },
    timeRange() {
      return this.startTime + "-" + this.endTime;
    },
    subject() {
      if (this.column.columnKey == "intervalText") {
        return "agent_home";
      }
      return this.column.columnKey;
    },
    interval() {
      return this.row["time_interval"];
    },
    request() {
      return { subject: this.subject, interval: this.interval };
    },
    value() {
      return this.row[this.column.columnKey];
    },
    formatted() {
      return this.column.formatter(
        this.row,
        this.column,
        this.value,
        this.column.$index
      );
    },
    detailSubject() {
      let subject = this.$t("column." + this.col.langKey);
      if (this.col.parent) {
        subject = this.$t("column." + this.col.parent.langKey) + "-" + subject;
      }
      return subject;
    },
    headerProps() {
      return {
        subject: this.detailSubject,
        interval: this.row["intervalText"],
        total: this.formatted,
        time: this.timeRange,
        subjectKey: this.column.columnKey,
        isEveryDay: this.isEveryDay,
      };
    },
    sortMethods() {
      if (!this.isEveryDay) {
        return {};
      }
      let methods = {};
      this.columns.forEach((column) => {
        if (column.children) {
          column.children.forEach((col) => {
            methods[col.name] = this.sortEveryDayData;
          });
        } else {
          methods[column.name] = this.sortEveryDayData;
        }
      });
      return methods;
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    this.columns = this.isEveryDay ? this.everyDayColumns : this.detailColumns;
  },
  methods: {
    fetch() {
      apis.dashboard.getDetailColumns(this.request).then((response) => {
        this.columns = response.data;
        this.$refs.table.init(this.request);
      });
    },
    handleLoaded(response) {
      this.startTime = response.start_time;
      this.endTime = response.end_time;
      if (!this.isEveryDay) {
        this.summaryData = response.total;
        // this.$nextTick(() => {
        //   this.$parent.$el.querySelector(".tg-pagination").scrollIntoView({
        //     behavior: "smooth",
        //   });
        // });
      }
      let appContainer = this.$parent.$el.parentElement.parentElement;
      let scrollHeight = appContainer.scrollHeight;
      appContainer.scrollTo({ left: 0, top: scrollHeight, behavior: "smooth" });
    },
    summary({ columns }) {
      let data = [];

      data = columns.map((c, index) => {
        if (index == 0) {
          return this.$t("component.table.summary");
        }

        let col = this.columns.find((col) => col.name === c.columnKey);

        if (!col) {
          return "";
        }

        let value = "";

        if (col.amount) {
          value = this.summaryData ? this.summaryData[c.columnKey] : "";
        }

        if (col.format) {
          value = formatter.format(value, col.format);
        }
        return value;
      });

      return data;
    },
    handleSortChange({ prop, order }) {
      if (this.isEveryDay) {
        return;
      }
      let request = { ...this.request };
      request.orderby = prop;
      request.direction = order == "ascending" ? "asc" : "desc";
      this.$refs.table.search(request);
    },
    handleExport(name) {
      let normalColumns = JSON.parse(JSON.stringify(this.columns));

      let headerRow = convertToRows(normalColumns);
      let columns = flatColumns(normalColumns);

      let table = this.$refs.table.$refs.ElTable;
      let data = table.store.states.filteredData;
      let ws = xlsx.makeSheet(headerRow, columns, data);
      let datestring = new Date().toISOString().replace(/[-:.]/g, "");
      xlsx.exportExcel(ws, name + "-" + datestring);
    },
  },
  watch: {
    options() {
      this.fetch();
    },
  },
};
</script>
